const locales = [
	'cs',
	'en'
]

module.exports = locales